import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
// import todoApp from './todo/reducer';
import chatApp from './chat/reducer';
import surveyListApp from './surveyList/reducer';
import surveyDetailApp from './surveyDetail/reducer';
import dashboardData from './dashboard/reducer';
import ticketData from './ticket/reducer';
import reportData from './report/reducer';
import settingData from './setting/reducer';
import companyData from './company/reducer';
import userData from './user/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  dashboardData,
  ticketData,
  reportData,
  settingData,

  companyData,

  userData,
  // todoApp,
  chatApp,
  surveyListApp,
  surveyDetailApp,
});

export default reducers;
